import Link, {LinkProps} from "next/link";
import clsMerge from "../util/clsMerge";
import {
	ButtonSizes,
	ButtonVariant,
	ButtonVariantProps,
	buttonStyles,
} from "./Button";
import {FCWithHTMLAttributes} from "../types/reactTypes";

export type LinkButtonProps = ButtonVariantProps &
	LinkProps &
	React.AnchorHTMLAttributes<HTMLAnchorElement>;

const LinkButton: FCWithHTMLAttributes<LinkButtonProps> = ({
	children,
	className,
	variant = ButtonVariant.PRIMARY,
	size = ButtonSizes.LARGE,
	...props
}) => {
	if (!props.href) {
		props.href = "/";
	}
	return (
		<Link
			className={clsMerge(
				buttonStyles({variant, size}),
				"inline-block",
				className
			)}
			{...props}
		>
			{children}
		</Link>
	);
};

export default LinkButton;
